import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { LegalDocumentSection } from "@-/dev.improve.haniverse.lib.legal";
import { View } from "@-/com.npmjs.react-native";

/** A titled paragraph block of a legal document body. */
export function LegalSection({ section }: { section: LegalDocumentSection }) {
  return (
    <View className="gap-3">
      <Text variant="h3">{section.title}</Text>
      <Text className="text-muted-foreground" selectable={true} variant="p">
        {section.paragraphs.join("\n\n")}
      </Text>
    </View>
  );
}
